import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useEnvironment } from 'contexts/environment'
import { Section, Heading, IconMessage, WrappedText } from '../s'
import Paragraph from 'components/typography/paragraph'
import { OrderedList, ListItem } from 'components/list'
import Link from 'components/link'
import { Ghost } from 'components/button'
import { Scrollable as Modal } from 'modals/generic'
import ExportUsers from 'pages/people/modals/export-users'
import {
    CheckCircleFilled as Success,
    InfoCircleFilled as Info
} from 'components/feather'
import { DownloadCloud as Export } from 'styled-icons/feather'

const AltinnSupportedFeatures = ({ salt }) => {
    const { environment } = useEnvironment()

    const [exporting, setExporting] = useState(false)

    return (
        <>
            <Section>
                <Heading>
                    <FormattedMessage
                        id="integration_heading_supported_features"
                        defaultMessage="Supported features" />
                </Heading>
                <OrderedList>
                    <ListItem>
                        <IconMessage className="success">
                            <Success size={20} />
                            <div>
                                <Paragraph>
                                    <strong>
                                        <FormattedMessage
                                            id="integration_altinn_feature_heading_fields_in_import"
                                            defaultMessage="Import sick leave from Altinn / NAV" />
                                    </strong>
                                    <br />
                                    <FormattedMessage
                                        id="integration_altinn_feature_text_fields_in_import"
                                        defaultMessage="Huma checks Altinn for new sick leave entries once a day. When a doctor adds a new sick leave, it is automatically created in Huma."
                                    />
                                </Paragraph>
                                <OrderedList>
                                    <ListItem>
                                        <IconMessage className="info">
                                            <Info size={20} />
                                            <div>
                                                <Paragraph>
                                                    <FormattedMessage
                                                        id="integration_altinn_message_valid_id"
                                                        defaultMessage="Sick leaves can only be created for users with a valid Norwegian identification number." />
                                                </Paragraph>
                                            </div>
                                        </IconMessage>
                                    </ListItem>
                                    <ListItem>
                                        <IconMessage className="info">
                                            <Info size={20} />
                                            <div>
                                                <Paragraph className="preserve-line-breaks">
                                                    <FormattedMessage
                                                        id="integration_altinn_message_sick_leave_follow_up_process"
                                                        defaultMessage="For now, the sick leave follow-up process, if activated, will only start for <strong>the first sick leave period</strong> coming from NAV / Altinn.\n\nIf a sick leave period is extended, the sick leave follow-up process will stop after the first sick leave registration has ended.\n\n<sickLeaveLink>Read more about the sick leave process</sickLeaveLink>"
                                                        values={{
                                                            sickLeaveLink: chunks => (
                                                                <Link
                                                                    href={`https://www.${environment.tld}/knowledge/how-to-work-with-sick-leave-follow-up`}
                                                                    target="_blank"
                                                                    className="constructive">
                                                                    {chunks}
                                                                </Link>
                                                            )
                                                        }} />
                                                </Paragraph>
                                            </div>
                                        </IconMessage>
                                    </ListItem>
                                </OrderedList>
                            </div>
                        </IconMessage>
                    </ListItem>
                </OrderedList>
                <WrappedText>
                    <Paragraph>
                        <FormattedMessage
                            id="integration_altinn_message_export"
                            defaultMessage="Export all user data to find employees that are missing a Norwegian identification number." />
                    </Paragraph>
                    <Ghost
                        onClick={() => setExporting(true)}
                        className="constructive"
                        icon={Export}>
                        <FormattedMessage
                            id="action_export_all_users"
                            defaultMessage="Export all users" />
                    </Ghost>
                </WrappedText>
            </Section>
            <Modal
                show={exporting}
                dismiss={() => setExporting(false)}
                salt={salt}>
                <ExportUsers
                    onDone={() => setExporting(false)}
                    salt={salt} />
            </Modal>
        </>
    )
}

export default AltinnSupportedFeatures